import React from "react";
import { Grid, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";


const BannerSuccess = ({ msg, project_id, project_type,userRole}) => {
  console.log("user role infor");
  console.log(userRole);
  console.log(project_type)

  return (
    <Grid
      item
      xs={12}
      style={{
        minHeight: "calc(100vh - 133px)",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        height: "100%"
      }}
    >
      <CheckCircleOutlineOutlinedIcon
        style={{ color: "#5ACA49", fontSize: "64px" }}
      ></CheckCircleOutlineOutlinedIcon>
      <h2 className="mt-2">Success!</h2>
      <h4 className="mt-2">{msg}</h4>
      <div style={{
        display: "flex",
        }}
      >
            <Link to={`/`}>
              <Button
                
                className="mt-5"
                style={{
                  color: "white",
                  backgroundColor: "#1176B5",
                  borderRadius: "4px",
                  boxShadow:
                    "0 0.4px 0.6px 0 rgba(0,0,0,0.37), 0 0.1px 0 0.4px #0A649D",
                  height: "40px",
                  width: "200px",
                  textTransform: "capitalize",
                  marginRight: "20px"
                }}
                onClick={() => {
                  setTimeout(() => {
                    window.location.reload();
                  }, 500);
                }}
              >
                Home
              </Button>
            </Link>
          
            <Link to={`/banner-history`}>
              <Button
                
                className="mt-5"
                style={{
                  color: "white",
                  backgroundColor: "#1176B5",
                  borderRadius: "4px",
                  boxShadow:
                    "0 0.4px 0.6px 0 rgba(0,0,0,0.37), 0 0.1px 0 0.4px #0A649D",
                  height: "40px",
                  width: "200px",
                  textTransform: "capitalize",
                  marginRight: "20px"
                }}
                onClick={() => {
                  setTimeout(() => {
                    window.location.reload();
                  }, 500);
                }}
              >
                Banner History
              </Button>
            </Link>
      </div>
    </Grid>
  );
};

export default BannerSuccess;
